import React from 'react';

import classNames from 'classnames';
import BsPagination from 'react-bootstrap/Pagination';

import { PageValuesT, PaginationLabel } from './PaginationLabel';
import { PaginationChevronIcon } from '../icons/PaginationChevronIcon';

import '@consumer-bootstrap/components/pagination.scss';
import '@consumer-bootstrap/index.scss';

export * from './PaginationLabel';

export type PaginationPropsT = {
  nextHandler: () => void;
  paginationValues: PageValuesT;
  prevHandler: () => void;
  className?: string;
  hideLabel?: boolean;
};
export type PaginationT = React.FC<PaginationPropsT>;

export const Pagination: PaginationT = ({
  className,
  hideLabel,
  nextHandler,
  paginationValues,
  prevHandler,
  ...props
}) => {
  const { hasMore, offset } = paginationValues;

  const classes = classNames([className, 'pagination-container']);

  return (
    <div className={classes}>
      {!hideLabel && <PaginationLabel {...paginationValues} />}

      <BsPagination {...props}>
        <BsPagination.Prev
          as="button"
          className="prev"
          disabled={offset <= 0}
          onClick={prevHandler}
        >
          <PaginationChevronIcon direction="backward" size="1.5rem" />
        </BsPagination.Prev>

        <BsPagination.Next
          as="button"
          className="next"
          disabled={!hasMore}
          onClick={nextHandler}
        >
          <PaginationChevronIcon direction="forward" size="1.5rem" />
        </BsPagination.Next>
      </BsPagination>
    </div>
  );
};
